
// function addToCart(productID){
//         let formData = {
//  'items': [{
//   'id': productID,
//   'quantity': 1
//   }]
// };
// console.log(productID)

// fetch(window.Shopify.routes.root + 'cart/add.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify(formData)
// })
// .then(response => {
//   return response.json();
  
// })
// .then(()=>{
//     console.log("Product Added")
//     window.location.href='/cart';
// })
// .catch((error) => {
//   console.error('Error:', error);
// });
//    }

const atcBtn = document.querySelector('#atc-btn');
const stickyAtcBtn = document.querySelector('#sticky-atc-btn');
atcBtn?.addEventListener('click', () => { addToCart(atcBtn.dataset.id, atcBtn); });
stickyAtcBtn?.addEventListener('click', () => { addToCart(stickyAtcBtn.dataset.id, stickyAtcBtn); });

async function addToCart(productID, button) {
  const item = { id: parseInt(productID), quantity: 1 };
  if (button.dataset.planId) item.selling_plan = parseInt(button.dataset.planId);
  const formData = { items: [item] };
  const originalText = button.innerHTML;

  try {
    button.innerHTML = 'Adding...';

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    if (!response.ok) throw new Error('Add to cart failed');

    const data = await response.json();
    button.innerHTML = 'Added ✓';

    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartResponse.json();

    // Dispatch cart:update event
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart }
    }));

    // Open custom cart drawer
    openCartDrawer();

    setTimeout(() => { button.innerHTML = originalText; }, 2000);

  } catch (err) {
    console.error(err);
    button.innerHTML = originalText;
  }
}



// ── CUSTOM CART DRAWER ──────────────────────────
function openCartDrawer() {
  document.getElementById('custom-cart-drawer').classList.add('open');
  document.getElementById('custom-cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

function closeCartDrawer() {
  document.getElementById('custom-cart-drawer').classList.remove('open');
  document.getElementById('custom-cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

async function refreshCartDrawer() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const list = document.getElementById('cart-drawer-list');
  const empty = document.getElementById('cart-drawer-empty');
  const footer = document.getElementById('cart-drawer-footer');
  const badge = document.getElementById('cart-count-badge');
  const subtotal = document.getElementById('cart-subtotal');


  badge.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
  subtotal.classList.remove('updating');
  subtotal.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });

  if (cart.item_count === 0) {
    list.innerHTML = '';
    empty.style.display = 'block';
    footer.style.display = 'none';
    return;
  }

  empty.style.display = 'none';
  footer.style.display = 'block';

  list.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <img class="cart-item-img" src="${item.image}" alt="${item.title}">
      <div>
        <div class="cart-item-title">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
        ${item.selling_plan_allocation ? `<div class="cart-item-variant" style="color:var(--coral);">↻ ${item.selling_plan_allocation.selling_plan.name}</div>` : ''}
        <div class="cart-item-qty">
          <button onclick="updateCartItem('${item.key}', ${item.quantity - 1})">−</button>
          <span>${item.quantity}</span>
          <button onclick="updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
        </div>
        <button class="cart-item-remove" onclick="updateCartItem('${item.key}', 0)">Remove</button>
      </div>
      <div class="cart-item-price">${(item.final_line_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency })}</div>
    </div>
  `).join('');
}

async function updateCartItem(key, quantity) {
  const item = document.querySelector(`[data-key="${key}"]`);
  const qtySpan = item?.querySelector('.cart-item-qty span');
  const priceEl = item?.querySelector('.cart-item-price');
  const subtotalEl = document.getElementById('cart-subtotal');
  const prevQty = qtySpan ? parseInt(qtySpan.textContent) : null;

  // Optimistic UI
  if (qtySpan && quantity > 0) qtySpan.textContent = quantity;
  if (quantity === 0 && item) item.style.opacity = '0.4';

  // Blur prices while updating (price stays visible through blur)
  if (priceEl) priceEl.classList.add('updating');
  if (subtotalEl) subtotalEl.classList.add('updating');

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error('Failed');
    refreshCartDrawer();
  } catch (err) {
    // Rollback on failure
    if (qtySpan && prevQty !== null) qtySpan.textContent = prevQty;
    if (item) item.style.opacity = '1';
    if (priceEl) priceEl.classList.remove('updating');
    if (subtotalEl) subtotalEl.classList.remove('updating');
    console.error('Cart update failed', err);
  }
}

// Close on overlay click
document.getElementById('custom-cart-overlay')?.addEventListener('click', closeCartDrawer);



